import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  Tooltip,
  Icon,
  Flex,
  Box,
} from "@chakra-ui/react";
import Select from "react-select";
import {
  newBorder,
  white,
  primary,
  textPrimary,
  hoverItemColor,
  textSecondary,
  primaryAlt,
  backgroundLight,
} from "../../utils/colors";
import { useTranslation } from "react-i18next";
import { shade } from "polished";
import { FaCircleInfo } from "react-icons/fa6";

const FormControlRole = ({
  label,
  labelFontSize,
  value,
  onChange,
  isMulti,
  isRequired,
  isTouched,
  isError,
  errorMessage,
  isSearchable,
  w,
  isSmall,
  explainTooltip,
  explainTooltipLabel,
}) => {
  const { t } = useTranslation();
  const generateStateOptions = () => {
    let options = [];
    options.push({
      value: "admin",
      label: t("role.admin"),
    });
    options.push({
      value: "employee",
      label: t("role.employee"),
    });
    options.push({
      value: "guest",
      label: t("role.guest"),
    });
    options.push({
      value: "custom",
      label: t("role.custom"),
    });

    return options;
  };

  const stateOptions = generateStateOptions();

  // CUSTOM STYLES
  const customStyles = {
    placeholder: (provided) => ({
      ...provided,
      color: "#718096", // Change this to your desired placeholder color
    }),
    control: (baseStyles, state) => ({
      ...baseStyles,
      borderColor: isError ? "red" : state.isFocused ? newBorder : newBorder,
      backgroundColor: white,
      border: `1px solid ${newBorder}`,
      fontSize: isSmall ? "0.875rem" : "0.938rem",
      fontWeight: "500",
      minHeight: isSmall ? "2.5rem" : "3rem",
      height: isMulti ? "initial" : isSmall ? "2.5rem" : "3rem",
      margin: "0",
      padding: "0 8px",
      borderRadius: "0.75rem",

      ":focus-visible": {
        borderColor: primary,
        boxShadow: `0 0 0 1px ${newBorder}`,
      },
      ":hover": {
        boxShadow: "none",
        outline: "none",
        cursor: "pointer",
        borderColor: "#cbd5e0",
      },
    }),

    menu: (provided) => ({
      ...provided,
      borderRadius: "0.75rem",
      boxShadow: "1px 1px 6px rgba(0, 0, 0, 0.3)",
      border: `0px solid ${newBorder}`,
      overflow: "hidden",
      zIndex: 90000,
    }),

    menuList: (provided) => ({
      ...provided,
      margin: "0",
      padding: "0",
      border: "none",
      boxShadow: "none",
    }),

    singleValue: (provided, state) => ({
      ...provided,
      opacity: state.isDisabled ? 0.5 : 1,
      color: textPrimary,
      margin: "0",
      padding: "0 0px",

      ":hover": {
        bg: "red",
      },
    }),

    option: (provided, state) => ({
      ...provided,

      // backgroundColor: state.isFocused ? backgroundLight : null,
      backgroundColor: state.isSelected ? primary : white, // Background color of selected option
      // color: state.isFocused ? textPrimary : state.data.color,
      color: state.isSelected ? "white" : textSecondary, // Color of text in options
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      margin: "0",
      padding: "0 1rem",
      fontWeight: "500",
      height: "48px",
      fontSize: "0.875rem",
      borderBottom: `1px solid ${newBorder}`,
      ":hover": {
        backgroundColor: state.isSelected
          ? shade(0.1, primary)
          : hoverItemColor,
        color: state.isSelected ? "white" : textPrimary,
      },
    }),
    multiValue: (provided, state) => ({
      ...provided,
      backgroundColor: primary,
      color: white,
      fontSize: "0.938rem",
    }),
    multiValueLabel: (provided, state) => ({
      ...provided,
      color: state.data.color,
    }),
    multiValueRemove: (provided, state) => ({
      ...provided,
      ":hover": {
        backgroundColor: state.data.bgDark,
        color: state.data.color,
      },
    }),
    groupHeading: (provided) => ({
      ...provided,
      fontSize: "11px",
      color: textSecondary,
      fontWeight: "500",
    }),
  };

  // LOG

  // console.log("stateOptions", stateOptions);

  return (
    <FormControl
      mb={4}
      isRequired={isRequired}
      isInvalid={isTouched && isError}
      w={w}
    >
      <FormLabel
        fontSize={labelFontSize ? labelFontSize : "sm"}
        position="relative"
        color={textPrimary}
        // w="100%"
      >
        {label ? (
          <Box align="center" width="initial" display="inline-block">
            <Flex align="center">
              {label}
              {explainTooltip && (
                <Tooltip
                  p="0.5rem 1rem"
                  placement="top"
                  borderRadius="1rem"
                  label={explainTooltipLabel ? explainTooltipLabel : "-"}
                >
                  <Flex
                    align="center"
                    ml={1}
                    color={shade(0.3, backgroundLight)}
                    _hover={{ cursor: "pointer", color: primaryAlt }}
                  >
                    <Icon as={FaCircleInfo} fontSize="0.875rem" />
                  </Flex>
                </Tooltip>
              )}
            </Flex>
          </Box>
        ) : null}

        {isError && isTouched && (
          <div>
            <FormErrorMessage fontSize="xs">{errorMessage}</FormErrorMessage>
          </div>
        )}
      </FormLabel>

      {/* <FormLabel
        fontSize={labelFontSize ? labelFontSize : "sm"}
        position="relative"
        color={textPrimary}
        // w="100%"
      >
        {label ? (
          <Box align="center" width="initial" display="inline-block">
            {label}
            <Flex align="center" position="absolute" right="-0.5rem" top="2px">
              {explainTooltip && (
                <Tooltip
                  p="0.5rem 1rem"
                  borderRadius="1rem"
                  label={explainTooltipLabel ? explainTooltipLabel : "-"}
                >
                  <Flex align="center" ml={1}>
                    <Icon
                      as={FaCircleInfo}
                      fontSize="0.875rem"
                      color={backgroundGrey}
                    />
                  </Flex>
                </Tooltip>
              )}
            </Flex>
          </Box>
        ) : null}

        {isError && isTouched && (
          <div>
            <FormErrorMessage fontSize="xs">{errorMessage}</FormErrorMessage>
          </div>
        )}
      </FormLabel> */}

      <Select
        isMenuOpen
        isSearchable={isSearchable}
        value={
          value ? stateOptions.find((option) => option.value === value) : null
        }
        onChange={onChange}
        options={stateOptions}
        placeholder={t("placeholder.selectAddressState")}
        // menuPortalTarget={document.body}
        styles={customStyles}
        // styles={{
        //   control: (baseStyles, state) => ({
        //     ...baseStyles,
        //     borderColor: isError
        //       ? "red"
        //       : state.isFocused
        //       ? newBorder
        //       : newBorder,
        //     borderRadius: "1rem",
        //     backgroundColor: white,
        //     border: `1px solid ${newBorder}`,
        //     fontSize: isSmall ? "0.875rem" : "0.938rem",
        //     fontWeight: "500",
        //     height: isSmall ? "2.5rem" : "3rem",
        //     padding: "0 0.25rem",
        //     zIndex: 9999,
        //     ":focus-visible": {
        //       borderColor: primary,
        //       boxShadow: `0 0 0 1px ${newBorder}`,
        //     },
        //   }),
        //   option: (provided, state) => ({
        //     ...provided,
        //     color: state.isSelected ? "white" : "black", // Color of text in options
        //     backgroundColor: state.isSelected ? primary : white, // Background color of selected option
        //     ":hover": {
        //       backgroundColor: primary, // Background color when hovering
        //       color: "white",
        //     },
        //   }),
        //   singleValue: (provided, state) => {
        //     const opacity = state.isDisabled ? 0.5 : 1;
        //     const transition = "opacity 300ms";

        //     return { ...provided, opacity, transition };
        //   },
        //   menuPortal: (base) => ({
        //     ...base,
        //     zIndex: 9999, // Use a high value to ensure it's on top of other elements
        //   }),
        //   menu: (base) => ({
        //     ...base,
        //     zIndex: 1, // Use a high value to ensure it's on top of other elements
        //     // You can add additional styles if needed
        //   }),
        //   menuPosition: "absolute",
        // }}
      />
    </FormControl>
  );
};

export default FormControlRole;
